import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

const SectionCard1: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.SectionCard1');

    return (
        <div className={styles.SectionCard1} id="SectionCard1" data-section-id={styles.SectionCard1} data-section-title={t('title')}>
            <EcoSpace />
            <EcoSectionCommon
                title={t('title')}
                desc={t('desc')}
                lChildren={t('btn')}
                lHref={`https://www.ecoflow.com/${locale}/ocean-pro-consultation?utm_source=oceanpro&utm_medium=orderpage`}
                lDataLayer={{
                    __btn_id1: styles.SectionCard1,
                    __btn_id2: `https://www.ecoflow.com/${locale}/ocean-pro-consultation?utm_source=oceanpro&utm_medium=orderpage`,
                }}
            />
            <div className="eco-content">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1755151836392/Group%201000007319.png"
                    pad="https://websiteoss.ecoflow.com/upload/image/1755151836392/Group%201000007319.png"
                    h5="https://websiteoss.ecoflow.com/upload/image/1755596401187/Frame%201612690338%20(1).png"
                />
                <div className="footer-desc">
                    {t.rich('footer_desc', {
                        t: (text: string) => (
                            <EcoLink className="terms-link" href="https://zenodo.org/records/15801701" target="_blank">
                                {text}
                            </EcoLink>
                        ),
                        p: (text: string) => (
                            <EcoLink
                                className="terms-link"
                                href="https://www.cnbc.com/2025/07/14/how-much-trumps-big-beautiful-bill-could-raise-electricity-costs.html"
                                target="_blank"
                            >
                                {text}
                            </EcoLink>
                        ),
                    })}
                </div>
            </div>
            <EcoSpace />
        </div>
    );
};

export default SectionCard1;
